module.exports = __webpack_public_path__ + "img/wind.cf2ddcf8.svg";